import React from 'react';
import {
  useState,
} from 'react';
import {
  Modal,
  Text,
  Banner,
} from '@shopify/polaris';
import TagListComponent from '../../components/TagListComponent';

function RemoveTagsDialog(props) {

  const [selectedTags, setSelectedTags] = useState([]);

  const handleTagClick =
    (tag) => {

      var newSelected = [...selectedTags, tag];
      setSelectedTags(newSelected);
    };

  const handleTagRemove =
    (tag) => {
      var index = selectedTags.indexOf(tag);

      if (index !== -1) {
        var newSelected = [
          ...selectedTags.slice(0, index),
          ...selectedTags.slice(index + 1)
        ];
        setSelectedTags(newSelected);
      }
    };

  const searchableTags = props.tags.filter(_ => !selectedTags.includes(_));

  return (<div>
    <Modal
      large
      fullScreen
      instant
      open={props.active}
      onClose={props.onCancel}
      title="Remove Tags"
      primaryAction={{
        content: props.executing ? 'Creating operation, please wait...' : 'Execute',
        loading: props.executing,
        onAction: () => props.onExecute(selectedTags),
      }}
      secondaryActions={[
        {
          content: 'Cancel',
          onAction: props.onCancel,
          disabled: props.executing
        },
      ]}
    >
      <Modal.Section title="Tags To Remove" titleHidden={false}>
        <Text variant="bodyLg" as="h1">
          Tags To Remove
        </Text>
        <br />

        {selectedTags.length === 0 && <Banner status='warning'>Please select at least one tag from the list below.</Banner>}

        <TagListComponent
          enableSearch={false}
          tags={selectedTags}
          tagDisplayState="removed"
          onTagRemove={handleTagRemove}
        />

      </Modal.Section>
      <Modal.Section title="Tags of products matching the filter conditions">
        <Text variant="bodyLg" as="h1">
          Tags of products matching the filter conditions
        </Text>
        <br />
        <TagListComponent
          searchBoxPlaceholder="Search to find tags to be removed"
          tags={searchableTags}
          enableSearch
          onTagClick={handleTagClick} />
      </Modal.Section>
    </Modal>
  </div>);
}

export default RemoveTagsDialog;